import { render } from "./UsuariosFormView.vue?vue&type=template&id=573ddfb2"
import script from "./UsuariosFormView.vue?vue&type=script&lang=js"
export * from "./UsuariosFormView.vue?vue&type=script&lang=js"

import "./UsuariosFormView.vue?vue&type=style&index=0&id=573ddfb2&lang=css"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__